/**
 * Cart Price Updater
 * Reads unit price from <product-buy-price data-price="260000">
 * and updates it when quantity changes.
 *
 * Add to: Assets/cart-price-updater.js
 * Load in layout/theme.liquid before </body>:
 *   <script src="{{ 'cart-price-updater.js' | asset_url }}" defer></script>
 */

(function () {

  function formatPrice(paise) {
    const amount = (paise / 100).toLocaleString('en-PK', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    return 'Rs.' + amount;
  }

  function updateButtonPrice() {
    const qtyInput = document.querySelector('quantity-input input[name="quantity"]');
    const priceEl = document.querySelector('product-buy-price[data-price]');

    if (!qtyInput || !priceEl) return;

    const qty = parseInt(qtyInput.value) || 1;

    // data-price is always the unit price in paise — set by the theme, never modified
    const unitPriceInPaise = parseInt(priceEl.getAttribute('data-price'));
    if (!unitPriceInPaise || isNaN(unitPriceInPaise)) return;

    // Update only the visible text — data-price attribute stays untouched
    priceEl.textContent = formatPrice(unitPriceInPaise * qty);
  }

  function init() {
    // Run once on load
    setTimeout(updateButtonPrice, 300);

    // +/- button clicks
    document.addEventListener('click', function (e) {
      if (e.target.closest('button[name="minus"], button[name="plus"]')) {
        setTimeout(updateButtonPrice, 80);
      }
    });

    // Direct typing into qty field
    document.addEventListener('change', function (e) {
      if (e.target.matches('quantity-input input[name="quantity"]')) {
        setTimeout(updateButtonPrice, 80);
      }
    });

    // Variant switch (250gm / 500gm / 1Kg) — theme updates data-price automatically
    document.addEventListener('variant:changed', function () {
      setTimeout(updateButtonPrice, 350);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();